import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberSliderComponent } from './components/number-slider/number-slider.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { RadioComponent } from './components/radio/radio.component';
import { FormsModule } from '@angular/forms';
import { DatePickerInlineComponent } from './components/date-picker-inline/date-picker-inline.component';
import { DatePickerInlineDaysComponent } from './components/date-picker-inline/components/date-picker-inline-days/date-picker-inline-days.component';
import { DatePickerInlineMonthsComponent } from './components/date-picker-inline/components/date-picker-inline-months/date-picker-inline-months.component';
import { DatePickerInlineYearsComponent } from './components/date-picker-inline/components/date-picker-inline-years/date-picker-inline-years.component';
import { DurationPickerComponent } from './components/duration-picker/duration-picker.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { IdeomUiCommonModule } from '../common/ideom-ui-common.module';

@NgModule({
  declarations: [
    NumberSliderComponent,
    CheckboxComponent,
    RadioComponent,
    DatePickerInlineComponent,
    DatePickerInlineDaysComponent,
    DatePickerInlineMonthsComponent,
    DatePickerInlineYearsComponent,
    DurationPickerComponent,
    FileUploaderComponent,
  ],
  imports: [CommonModule, FormsModule, IdeomUiCommonModule],
  exports: [
    NumberSliderComponent,
    CheckboxComponent,
    RadioComponent,
    DatePickerInlineComponent,
    DurationPickerComponent,
    FileUploaderComponent,
  ],
  entryComponents: [FileUploaderComponent],
})
export class IdeomFormModule {}
